/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateIdentifiedClientRequest
 */
export interface UpdateIdentifiedClientRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateIdentifiedClientRequest
     */
    id: string;
}

/**
 * Check if a given object implements the UpdateIdentifiedClientRequest interface.
 */
export function instanceOfUpdateIdentifiedClientRequest(value: object): value is UpdateIdentifiedClientRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function UpdateIdentifiedClientRequestFromJSON(json: any): UpdateIdentifiedClientRequest {
    return UpdateIdentifiedClientRequestFromJSONTyped(json, false);
}

export function UpdateIdentifiedClientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateIdentifiedClientRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function UpdateIdentifiedClientRequestToJSON(value?: UpdateIdentifiedClientRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
    };
}

